<template>
  <modal ref="modal" static-backdrop width="720px" @closed="close">
    <div class="modal-header">
      <h5 class="modal-title">Avatar looks</h5>
      <button type="button" class="btn-close" @click="$refs.modal.close"></button>
    </div>
    <div class="modal-body">
      <div class="row row-cards">
        <div class="col-6 col-sm-4" v-for="look in looks" :key="look.id">
          <div :class="'card position-relative ' + (selectedLookId === look.id ? 'card-active' : '')" @click.prevent="selectedLookId = look.id">
            <div class="card-body p-0">
              <img :src="look.image" class="avatar-image"/>
            </div>
            <div class="position-absolute avatar-name">
              <div class="badge bg-secondary-lt opacity-80">{{ look.name }}</div>
            </div>
            <div class="position-absolute avatar-preview-button cursor-pointer" v-if="look.video_preview_url">
              <div class="badge bg-primary-lt opacity-80" @click="preview(look)">Preview</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" @click="confirm">Select look</button>
    </div>
  </modal>
</template>
<script>
export default {
    data() {
        return {
            selectedLookId: null,
            looks: []
        };
    },
    methods: {
        open(selectedLookId, looks) {
            this.selectedLookId = selectedLookId;
            this.looks = looks;
            this.$refs.modal.open();
        },
        close() {
            this.selectedLookId = null;
            this.looks = [];
        },
        preview(look) {
            this.$emit("preview", look);
        },
        confirm() {
            this.$emit("select", this.selectedLookId);
            this.$refs.modal.close();
        }
    }
};
</script>
